import { http } from '../request'
import request from '../request'  // 导入原始 axios 实例以支持 responseType
import type {
  WalletTransactionItem,
  WalletListResponse,
} from '../types/wallet'
import type {
  AdminWalletListRequest,
  AdminWalletFilterStats,
  AdminManualRechargeRequest,
  AdminManualWithdrawRequest,
  WithdrawalRequestItem,
  WithdrawalRequestListResponse,
  WithdrawalRequestListRequest,
  WithdrawalRequestStats,
  BatchValidateRequest,
  BatchValidateResponse,
  BatchRejectRequest,
  BatchRejectResponse,
  GenerateBatchFormRequest,
  GenerateBatchFormResponse,
  BatchCompleteRequest,
  BatchCompleteResponse,
  RejectWithdrawalRequest,
  FinanceReportRequest,
  FinanceReportData,
  FinanceDetailRequest,
  FinanceDetailResponse
} from '../types_admin'

export const adminWalletApi = {
  // 管理端：流水列表
  getTransactionList(params?: AdminWalletListRequest): Promise<WalletListResponse & { stats?: AdminWalletFilterStats }> {
    return http.list<WalletTransactionItem>('/api/admin/wallet/transactions/', params) as unknown as Promise<
      WalletListResponse & { stats?: AdminWalletFilterStats }
    >
  },

  // 管理端：人工充值
  manualRecharge(data: AdminManualRechargeRequest): Promise<WalletTransactionItem> {
    return http.post('/api/admin/wallet/transactions/recharge/', data)
  },

  // 管理端：人工提现
  manualWithdraw(data: AdminManualWithdrawRequest): Promise<WalletTransactionItem> {
    return http.post('/api/admin/wallet/transactions/withdraw/', data)
  },

  // 管理端：补充截图
  appendEvidence(id: number, images: string[]): Promise<WalletTransactionItem> {
    return http.post(`/api/admin/wallet/transactions/${id}/append-evidence/`, { images })
  },

  // 提现申请管理
  // 获取提现申请列表
  getWithdrawalRequestList(params?: WithdrawalRequestListRequest): Promise<WithdrawalRequestListResponse> {
    return http.list<WithdrawalRequestItem>('/api/admin/wallet/withdrawal-requests/', params)
  },

  // 单个批准/拒绝接口已下线

  // 获取提现申请详情
  getWithdrawalRequestDetail(id: number): Promise<WithdrawalRequestItem> {
    return http.get(`/api/admin/wallet/withdrawal-requests/${id}/`)
  },

  // 获取提现申请统计（与users保持一致的路径风格 statistics）
  getWithdrawalRequestStats(): Promise<WithdrawalRequestStats> {
    return http.get('/api/admin/wallet/withdrawal-requests/statistics/')
  },

  // ==================== 批量提现相关API ====================
  batchValidate(data: BatchValidateRequest): Promise<BatchValidateResponse> {
    return http.post('/api/admin/wallet/withdrawal-requests/batch-validate/', data)
  },

  batchReject(data: BatchRejectRequest): Promise<BatchRejectResponse> {
    return http.post('/api/admin/wallet/withdrawal-requests/batch-reject/', data)
  },

  generateBatchForm(data: GenerateBatchFormRequest): Promise<GenerateBatchFormResponse> {
    return http.post('/api/admin/wallet/withdrawal-requests/generate-batch-form/', data)
  },

  // 批量完成提现申请
  batchComplete(data: BatchCompleteRequest): Promise<BatchCompleteResponse> {
    return http.post('/api/admin/wallet/withdrawal-requests/batch-complete/', data)
  },

  // 单个拒绝提现申请
  rejectRequest(id: number, data: RejectWithdrawalRequest): Promise<WithdrawalRequestItem> {
    return http.post(`/api/admin/wallet/withdrawal-requests/${id}/reject/`, data)
  },

  // 获取钱包流水关联的订单详情（包含账号快照）- 管理端
  getTransactionOrderDetail(id: number): Promise<import('../types/wallet').WalletTransactionOrderDetail> {
    return http.get(`/api/admin/wallet/transactions/${id}/order-detail/`)
  },

  // 获取财务报表
  getFinanceReport(params: FinanceReportRequest): Promise<FinanceReportData> {
    return http.get('/api/admin/wallet/transactions/finance-report/', { params })
  },

  // 获取财务明细列表
  getFinanceDetail(params: FinanceDetailRequest): Promise<FinanceDetailResponse> {
    return http.get('/api/admin/wallet/transactions/finance-detail/', { params })
  },

  // 导出财务数据为CSV
  exportFinanceCSV(params: { type: string; date?: string; types?: string; search?: string }): Promise<Blob> {
    return request.get('/api/admin/wallet/transactions/finance-export-csv/', {
      params,
      responseType: 'blob'
    })
  }
}

export default adminWalletApi

